var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9722 0.0283213C31.9722 0.0283213 20.0002 0.000322744 10.6669 9.33366C10.2353 9.76521 9.85033 10.2283 9.51025 10.7145C7.85493 10.5846 5.32619 10.6371 4.036 11.9282C1.00933 14.9548 0 20.0002 0 20.0002L6.66699 19.0477V21.3337L10.667 25.3337H12.9524L12 32.0003C12 32.0003 17.0453 30.9909 20.072 27.9643C21.3629 26.6742 21.4155 24.1458 21.2857 22.4905C21.772 22.1504 22.2352 21.7653 22.6669 21.3337C32.0002 12.0003 31.9722 0.0283213 31.9722 0.0283213ZM18.6669 10.667C18.6669 9.19366 19.8602 8.00032 21.3335 8.00032C22.8069 8.00032 24.0002 9.19366 24.0002 10.667C24.0002 12.1403 22.8069 13.3337 21.3335 13.3337C19.8602 13.3337 18.6669 12.1403 18.6669 10.667ZM8.66272 25.8847C8.68156 25.8515 8.7004 25.8183 8.72248 25.7868L9.33315 26.3962C9.19981 26.9028 8.94648 27.3842 8.55048 27.7802C6.70515 29.6255 2.68381 29.3122 2.68381 29.3122C2.68381 29.3122 2.39448 25.2668 4.21581 23.4455C4.61181 23.0495 5.09315 22.7962 5.59981 22.6628L6.20915 23.2735C6.1765 23.297 6.14209 23.3165 6.10771 23.3361C6.05226 23.3676 5.99689 23.3991 5.94915 23.4468C4.64781 24.7468 5.29848 26.6975 5.29848 26.6975C5.29848 26.6975 7.24915 27.3468 8.54915 26.0468C8.59801 25.9988 8.63038 25.9417 8.66272 25.8847Z",
    fill: "#F8D210"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.3d183947c4978e8782627be5dadb0d7d.svg";
export { ForwardRef as ReactComponent };